import { InfoOutlineIcon } from '@chakra-ui/icons';
import { Checkbox, Flex, Tooltip } from '@chakra-ui/react';

import { ADAPTIVE_MAP } from '../../hooks/useAdaptiveChartType';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import type { PositionedItem } from '../PageConfigProvider/types/item';

const ADAPTIVE_LABELS: Record<string, string> = {
  metric: 'Single-entity metric',
  treemap: 'Single-entity treemap',
};

const ADAPTIVE_TOOLTIPS: Record<string, string> = {
  metric: 'Show single-metric view when one entity is selected.',
  treemap: 'Show treemap when one entity is selected.',
};

type AdaptiveChartSelectorProps = {
  item: PositionedItem;
  isDisabled?: boolean;
};

export const AdaptiveChartSelector = ({
  item,
  isDisabled = false,
}: AdaptiveChartSelectorProps) => {
  const { dispatch } = useTabContentConfig();
  const id = item?.id;
  const chartType = item?.plot?.chartType;
  const adaptiveTarget = chartType ? ADAPTIVE_MAP[chartType] : undefined;
  const isChecked = item?.plot?.adaptive ?? false;

  if (!adaptiveTarget) {
    return null;
  }

  const label = ADAPTIVE_LABELS[adaptiveTarget];
  const tooltipLabel = ADAPTIVE_TOOLTIPS[adaptiveTarget];

  return (
    <Flex align="center" gap={2}>
      <Checkbox
        colorScheme="green"
        size="sm"
        isChecked={isChecked}
        isDisabled={isDisabled}
        onChange={(e) => {
          if (id) {
            dispatch({
              type: 'UPDATE_ITEM_ADAPTIVE',
              payload: { id, adaptive: e.target.checked },
            });
          }
        }}
      >
        {label}
      </Checkbox>
      <Tooltip label={tooltipLabel} fontSize="xs" hasArrow placement="top">
        <span>
          <InfoOutlineIcon
            boxSize={3.5}
            color="gray.400"
            aria-label="Adaptive chart info"
          />
        </span>
      </Tooltip>
    </Flex>
  );
};
